import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { Philosophy } from "./pages/Philosophy";
import { OurStory } from "./pages/OurStory";
import { TheWork } from "./pages/TheWork";
import { TheStable } from "./pages/TheStable";
import { Apply } from "./pages/Apply";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

function App() {
  return (
    <div className="App bg-[#050505] min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/philosophy" element={<Philosophy />} />
            <Route path="/our-story" element={<OurStory />} />
            <Route path="/the-work" element={<TheWork />} />
            <Route path="/the-stable" element={<TheStable />} />
            <Route path="/apply" element={<Apply />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
